import type {
  CompRef,
  DocumentServicesObject,
} from '@wix/document-services-types';
import type { HostAPI } from '../types';

import { VirtualElement, VirtualElementAPIType } from '../api';
import type { VirtualElementProvider } from '../api/providers/VirtualElementProvider';
import type { ManifestStore, PanelStore } from '../stores';
import { ManifestChangeDetection } from '../ManifestChangeDetection';
import { ManifestServiceStats } from '../ManifestServiceStats';
import { ExperimentsAPI } from '@wix/editorx-core-api';
import type {
  EditorPointer,
  EditorPointerServiceAPI,
} from '@wix/editor-document-logic-api';

export abstract class AbstractComponentsPlatformService {
  constructor(
    protected readonly dm: DocumentServicesObject,
    protected readonly hostAPI: HostAPI,
    protected readonly virtualElementProvider: VirtualElementProvider,
    protected readonly manifestStore: ManifestStore,
    protected readonly panelStore: PanelStore,
    protected readonly editorPointerAPI: EditorPointerServiceAPI,
    protected readonly manifestChangeDetection: ManifestChangeDetection,
    protected readonly manifestServiceStats: ManifestServiceStats,
    readonly experimentsAPI: ExperimentsAPI,
  ) {}

  extractVirtualElement(
    editorPointers: EditorPointer<CompRef> | EditorPointer<CompRef>[],
  ): VirtualElement<VirtualElementAPIType.VirtualManifestAPI> {
    return this.virtualElementProvider.buildVirtualElement({
      editorPointers: Array.isArray(editorPointers)
        ? editorPointers
        : [editorPointers],
    });
  }
}
